<template>
  <div>
    <div class="bar_title mb-8 shadow-lg">
      <p class="title_bar_text">Mis asignaciones</p>
      <p>Gestiona tus clientes asignados</p>
    </div>

    <div
      class="flex items-center gap-10 text-lg text-center md:text-start leading-none md:leading-5 mb-4"
      style="font-weight: 500"
    >
      <span
        >Total saldo actual: <br class="block md:hidden" />
        <span v-if="total_cobranza" style="color: orange">
          {{ total_cobranza | currency }}
        </span>
        <span v-else style="color: orange">
          {{ 0 | currency }}
        </span>
      </span>
      <span
        >Cantidad clientes: <br class="block md:hidden" />
        <span style="color: orange">{{ data_cobranza.length | numberFormat }}</span></span
      >
    </div>

    <vs-divider />

    <balance_data
      v-if="data_cobranza.length > 0"
      @search_cobranza="search_cobranza"
      :data_cobranza="data_cobranza"
      :companies="companies"
      :min_range="min_range"
      :max_range="max_range"
    ></balance_data>

    <vs-popup title="Filtros" :active.sync="filters_modals">
      <section v-if="show_filters">
        <div class="grid grid-cols-2 gap-5 px-10">

          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Fecha último pago</label>
            <datepicker name="dateLastPass" v-model="dateLastPass"></datepicker>
          </div>
          
          
          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Fecha último viaje</label>
            <datepicker name="dateLastPass" v-model="dateLastPass"></datepicker>
          </div>
          
          <div class="flex flex-col gap-5">
            <label for="accountType">Tipo de cuenta</label>
            <v-select
              id="accountType"
              class="w-full style-chooser"
              :options="accounts"
              v-model="accountType"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="panapass" class="w-full">Panapass</label>
            <input
              id="panapass"
              class="w-full input_ena input_query shadow-lg"
              placeholder="Ingrese el panapass"
              type="text"
              ref="search_field1"
              v-model="search_field1_panapass"
              @input="formatInput"
            />
          </div>

          <div class="flex flex-col gap-5">
            <label for="statusCobranza" class="w-full">Estado de cobro</label>
            <v-select
              id="statusCobranza"
              class="w-full style-chooser"
              :options="cobranza_types"
              v-model="status_cobranza"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Segmento</label>
            <v-select
              class="style-chooser w-full"
              :options="segmentaciones"
              v-model="seg_selected"
            >
            </v-select>
          </div>
          
          <div class="flex flex-col gap-5">
            <label for="collector" class="w-full">Antiguedad</label>
            <v-select
              class="style-chooser w-full"
              :options="antiguedades"
              v-model="ant_selected"
            >
            </v-select>
          </div>

          <div class="flex flex-col gap-5">
            <label for="statusEmail" class="w-full">Envío email</label>
            <v-select
              id="statusEmail"
              class="w-full style-chooser"
              :options="status_email_options"
              v-model="status_email"
            >
            </v-select>
          </div>
        </div>
        <div class="flex justify-end items-center gap-5 mt-10 px-10">
          <button
            style="color: #9d9d9d"
            class="w-16 h-16 border-none bg-transparent outline-none rounded-full shadow-lg hover:shadow-md p-2 flex items-center justify-center cursor-pointer transition-all ease-in-out duration-200"
            @click="search_with_filters()"
          >
            <check-icon size="1.5x" class="custom-class" />
          </button>
          <button
            style="color: #9d9d9d"
            class="w-16 h-16 border-none bg-transparent outline-none rounded-full shadow-lg hover:shadow-md p-2 flex items-center justify-center cursor-pointer transition-all ease-in-out duration-200"
            @click="hidden_filters_modals()"
          >
            <x-icon size="1.5x" class="custom-class" />
          </button>
        </div>
      </section>

    </vs-popup>
  </div>
</template>
<script>
import axios from "@/axios";
import Swal from "sweetalert2";
import { CheckIcon, XIcon } from "vue-feather-icons";
import vSelect from "vue-select";
import balance_data from "./partials/balance_data.vue";
import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";


export default {
  components: {
    balance_data,
    vSelect,
    Datepicker,
    CheckIcon,
    XIcon,
  },
  data() {
    return {
      companies: [],
      users: [],
      config: null,
      min_range: 999999999,
      max_range: 999999999,
      total_cobranza: 0,
      data_cobranza: [],
      antiguedades: [],
      segmentaciones: [],
      fechas: [],
      type_search: 1,
      ant_selected: null,
      seg_selected: null,
      dateLastPass: "",
      dateLastPass: "",
      valorTotal: 0,
      internalValue: "",
      search_field1: "",
      filters_modals: false,
      show_filters: false,
      accounts: [
        { label: "Prepago", value: "Prepago" },
        { label: "Prepago recurrente", value: "Prepago recurrente" },
        { label: "Postpago", value: "Postpago" },
        { label: "No afiliados", value: "NULL" },
      ],
      cobranza_types: [
        { label: "Todos", value: '' },
        { label: "Sin Asignar", value: 3 },
        { label: "Asignados Pendientes", value: 'pendientes' },
        { label: "Cobrados", value: 1 },
      ],
      accountType: { label: "", value: "" },
      gestor: { label: "", value: "" },
      gestores: [],
      role: null,
      collector: { label: "", value: "" },
      status_cobranza: { label: "", value: "" },
      collectors: [],
      status_email: { label: "", value: "" },
      status_email_options: [
        { label: "Todos", value: "" },
        { label: "Enviado", value: "1" },
        { label: "No enviado", value: "0" },
      ],
    };
  },
  computed: {
    search_field1_panapass: {
      get() {
        // Si internalValue está vacío, muestra una cadena vacía; de lo contrario, completa con ceros
        return this.internalValue ? this.internalValue.padStart(10, "0") : "";
      },
      set(value) {
        // Elimina ceros a la izquierda y limita el valor a 10 caracteres
        this.internalValue = value.replace(/^0+/, "").slice(0, 10);
      },
    },
  },
  mounted() {
    this.config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.accessToken,
      },
    };
    this.getCompanies();
    this.role = JSON.parse(localStorage.getItem("user_session"));
    this.search_with_filters();
  },

  methods: {
    customFormat(date) {
      if (!date) return null;
      const d = new Date(date);
      if (isNaN(d)) return null;
      const pad = n => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    },
    hidden_filters_modals() {
      this.search_field1_panapass = "";
      this.search_field1 = "";
      this.filters_modals = false;
      this.show_filters = false;
    },
    formatInput(event) {
      const value = event.target.value;
      // Actualiza el valor interno después de eliminar ceros a la izquierda y limitar la longitud
      this.displayValue = value;
      this.search_field1 = this.search_field1_panapass;
    },
    getCompanies() {
      this.$vs.loading();
      let me = this;
      axios
        .get(`auth/getCompanies`, this.config)
        .then(function (response) {
          me.companies = response.data.data;
          me.antiguedades = response.data.antiguedades;
          me.segmentaciones = response.data.segmentaciones;
          me.fechas = response.data.fechas;
          me.gestores = response.data.gestores_ena;

          me.$vs.loading.close();
        })
        .catch(function (error) {
          me.$vs.loading.close();
        });
    },
    search_with_filters() {
      this.search_cobranza();
      this.filters_modals = false;
    },
    search_cobranza() {
      this.filters_modals = false;
      this.total_cobranza = 0;
      let ant_selected = this.ant_selected != null ? this.ant_selected.id : "";
      let seg_selected = this.seg_selected != null ? this.seg_selected.id : "";
      let accountType = this.accountType ? this.accountType.value : ''
      let statusCobranza = this.status_cobranza ? this.status_cobranza.value : ''
      let gestor = this.gestor ? this.gestor.id : ''
      let statusEmail = this.status_email ? this.status_email.value : ''

      const dateLastPass = this.customFormat(this.dateLastPass)

      let baseURL = "/auth/getDataCobranza";
      let params = {
        type_search: this.type_search,
        min_range: this.min_range*-1,
        max_range: this.max_range,
        panapass: this.search_field1,
        ant_selected: ant_selected,
        seg_selected: seg_selected,
        dateLastPass: dateLastPass,
        dateLastPass: dateLastPass,
        accountType: accountType,
        gestor: gestor,
        user_id: this.role.id,
        status_cobranza: statusCobranza,
        status_email: statusEmail,
      };

      // Construcción dinámica de la URL
      let queryString = Object.keys(params)
        .filter((key) => params[key] !== "" && params[key] !== undefined) // Filtra los parámetros vacíos o indefinidos
        .map(
          (key) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
        ) // Mapea a formato de URL
        .join("&");

      // URL completa
      let fullURL = `${baseURL}?${queryString}`;

      this.$vs.loading();
      let me = this;
      axios
        .get(fullURL, this.config)
        .then(function (response) {


          me.data_cobranza = me.filteredData(response.data);

          me.data_cobranza.map(function (value, key) {
            me.total_cobranza += parseFloat(
              Math.abs(value.valorTotal_float)
            );
          });

          me.$vs.loading.close();
        })
        .catch(function (error) {
          console.log(error);
          Swal.fire({
            title: "Ops! algo ha salido mal",
            text: "Intente con un rango de valores más ajustado",
            icon: "info",
          });
          me.data_cobranza = [];
          me.$vs.loading.close();
        });
      this.hidden_filters_modals();
    },
    filteredData(data_cobranza) {
      const grouped = data_cobranza.reduce((acc, curr) => {
        const key = `${curr.plate}|${curr.panapass}`;
        if (!acc[key]) {
          acc[key] = curr;
        } else {
          const currentAccDate = new Date(acc[key].gcc_created_at_formated);
          const currDate = new Date(curr.gcc_created_at_formated);
          if (currDate > currentAccDate) {
            acc[key] = curr;
          }
        }
        return acc;
      }, {});

      return Object.values(grouped);
    },
  },
};
</script>
<style lang="scss" scoped>
.bar_title {
  background-color: #21409a;
  border-radius: 10px;
  padding: 10px 10px 10px 20px;
  color: white;
  font-size: 2.3vh;
  font-weight: 300;
}

.radio_ant {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 20px; /* Ajusta este valor según tus necesidades */
  height: 20px; /* Ajusta este valor según tus necesidades */
  border-radius: 50%;
  border: 2px solid #787878; /* Cambia el color del borde si lo deseas */
  outline: none;
  cursor: pointer;
}

.radio_ant:checked {
  background-color: #21409a; /* Cambia el color de fondo cuando está seleccionado */
}
</style>
